import React from 'react';
import { Box } from '@material-ui/core';
import styles from './style.module.scss';
import ResultCell from './ResultCell';

const GlobalSearchResults = props => {
  const { searchResults } = props;

  return (
    <div className={styles.GlobalSearchResultsContainer}>
      <Box boxShadow={2} className={styles.GlobalSearchResultsContent}>
        {
          Object.keys(searchResults).map(resource => (
            <div key={resource} className={styles.ResourceContainer}>
              <div className={styles.ResourceHeaderContainer}>
                <span className={styles.ResourceHeaderText}>
                  {resource}
                </span>
              </div>
              {
                searchResults[resource].length
                  ? searchResults[resource].map((item, key) => (
                    <ResultCell clearSearchResults={props.clearSearchResults} key={key} item={item} resource={resource} />
                  ))
                  :
                  <div className={styles.ResourceItemContainer}>
                    <span className={styles.notFoundText}>No {resource} found matching search.</span>
                  </div>
              }
            </div>
          ))
        }
      </Box>
    </div>
  );
};

export default GlobalSearchResults;
